import zero from '../../../client/assets/images/bil_rapsfalt.jpg';
import one from '../../../client/assets/images/raps.jpg';
import two from '../../../client/assets/images/gullviks.jpg';
import tree from '../../../client/assets/images/bil_closeup.jpg';

const imageUrls = [
    zero,
    one,
    two,
    tree,
];

export const getImageUrlByIndex = (index: number) => imageUrls[index];
